/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import cx from 'classnames';

import { LogoMakeType } from './LogoMake.helpers';

import styles from './LogoMake.module.scss';

type LogoMakeProps = {
  className?: string;
  element?: React.ElementType;
  make: LogoMakeType;
  small?: boolean;
  webp?: boolean;
}

export const LogoMake = ({
  className,
  element: Element = 'div',
  make,
  small = false,
  webp = false,
  ...p
}: LogoMakeProps) => {
  const classNames = cx(
    className,
    styles.logoMake,
    styles[make],
    {
      [styles.small]: small,
      [styles.webp]: webp,
    },
  );

  const logoMakeExtension = webp ? `webp/${make}.webp` : `${make}.png`;

  const logoMakeUrl = make?.trim() ? logoMakeExtension : null;

  const inlineStyles = {
    '--logo-make-bg': logoMakeUrl ? `url(/makesLogos/${logoMakeUrl})` : 'none',
  } as React.CSSProperties;

  return (
    <Element className={classNames} style={inlineStyles} {...p} />
  );
};
